import { memo } from "react";
import { FleetTireAddRow } from "services/api/fleet/tires/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { TIRE_TYPE_BACKGROUND } from "ui/modules/fleet/tires/pages/TireSetSearchPage/components/TireSetSearchResults/consts";

interface TireReadOnlyRowProps {
    item: FleetTireAddRow;
    index: number;
    label: string;
    dirtyFields?: Set<string>;
    onDeleteClick: (event: React.MouseEvent<HTMLSpanElement>, id: string) => void;
}

const TireReadOnlyRow: React.FC<TireReadOnlyRowProps> = (props) => {
    const { item, index, label, dirtyFields, onDeleteClick } = props;

    const dirty = (field: string) => dirtyFields?.has(field) ? "bg-amber-50" : "";

    return (
        <tr className="border-b border-slate-200 hover:bg-slate-50 text-slate-900">
            <td className="px-4 py-4 text-sm font-medium text-slate-400">{index + 1}</td>
            <td className="px-4 py-4 text-sm font-medium">{label}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("width")}`}>{item.width ?? "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("height")}`}>{item.height ?? "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("radius")}`}>{item.radius ?? "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("tireManufacturerId")}`}>{item.tireManufacturer?.name ?? "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("tireTypeId")}`}>
                <div className="flex gap-1.5 items-center">
                    {item.tireType && TIRE_TYPE_BACKGROUND(item.tireType?.id)}
                    {item.tireType?.name ?? "-"}
                </div>
            </td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("dot")}`}>{item.dot && item.dot > 0 ? item.dot : "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium ${dirty("profileDepth")}`}>{item.profileDepth && item.profileDepth > 0 ? `${item.profileDepth}` : "-"}</td>
            <td className={`px-4 py-4 text-sm font-medium text-center ${dirty("rof")}`}>{item.rof ? "Da" : "Ne"}</td>
            <td className="px-4 py-2">
                {item.id && (
                    <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
                        <ButtonMenuItem startIcon="/media/icons/trash.svg" variant="remove" onClick={(e) => onDeleteClick(e, item.id ?? "")}>
                            Obriši
                        </ButtonMenuItem>
                    </ButtonMenu>
                )}
            </td>
        </tr>
    );
};

export default memo(TireReadOnlyRow);
